import { render, staticRenderFns } from "./healthInfo.vue?vue&type=template&id=fad384de&scoped=true&"
import script from "./healthInfo.vue?vue&type=script&lang=js&"
export * from "./healthInfo.vue?vue&type=script&lang=js&"
import style0 from "./healthInfo.vue?vue&type=style&index=0&id=fad384de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad384de",
  null
  
)

export default component.exports